import { Component, Input, OnInit, ViewChild, AfterViewInit, TemplateRef, Injector, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ChildParentTalk } from '../../data-models/child-parent-talk';
import { Http, RequestOptions, Headers } from '@angular/http';
import { FormOptions, FormMode } from '../../data-models/form-options';

@Component({
    selector: 'easy-form',
    templateUrl: 'form.component.html',
    styles: [
        `
        form {
            width : 100%;
        }
        `
    ]
})
export class EasyFormComponent extends ChildParentTalk implements OnInit, AfterViewInit {

    get familyId() { return 'form'; }

    @Input() localizationSource: string;
    @Input() width: string;
    @Input() options: FormOptions;
    @Input() formGroup: FormGroup;
    @Input() beforeSubmit: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

    @Output() formSubmit: EventEmitter<any> = new EventEmitter<any>();

    get isInline() {
        return this.options.inlineForm;
    }
    set isInline(_val) { }

    constructor(private http: Http, protected injector: Injector) {
        super(injector);
    }

    getUrl(apiEndPoint: string, params: string[]) {
        if (!apiEndPoint) {
            throw new TypeError("API EndPoint can't be empty");
        }

        params = params || [];
        let n = params.length;
        for (let i = 0; i < n; i++) {
            apiEndPoint = apiEndPoint.replace('{' + i + '}', params[i]);
        }
        return apiEndPoint;
    }

    onSubmit() {
        if (!this.formGroup.valid) {
            console.warn("formgroup is not valid");
        } else {
            this.beforeSubmit.emit(this.formGroup);
            this.formSubmit.emit(Object.assign(this.formGroup.value));
        }
    }

    ngOnInit() {

        if (!this.options) {
            this.options = new FormOptions();
        }

        this.getData();
    }

    getData() {
        if (!this.options.dataGetterEnabled) return;

        let headers = this.getHeaders();
        let url = this.getUrl(this.options.apiEndPoint, this.options.params);
        this.http.get(url, { headers: headers })
            .map(x => x.json())
            .subscribe(x => {
                this.formGroup.patchValue(x);
            });
    }

    getHeaders(): Headers {
        let token = localStorage.getItem('token');
        let headers = new Headers();
        headers.append("Authorization", token);
        return headers;
    }

    submit() {
        console.log(this.formGroup.valid);

        let obj = Object.assign({}, this.formGroup.value);
        for (var key in this.formGroup.controls) {
            let control = this.formGroup.controls[key];
            if (control.disabled) delete obj[key];
        }

        let url = this.getUrl(this.options.apiEndPoint, this.options.params);

        let observable;
        if (this.options.mode == FormMode.Create) {
            observable = this.http.post(url, { user: obj }, { headers: this.getHeaders() })
        } else {
            observable = this.http.post(url, { user: obj }, { headers: this.getHeaders() })
        }

        observable
            .map(x => x.json())
            .subscribe(x => {
                // this.formGroup.patchValue(x);
            });
    }

    ngAfterViewInit() {

    }

    tellYourParents() {

    }

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/form/form.component.ts